import ct from "class-types.macro";

export const baseFieldStyle = (failedValidation: boolean | undefined) => {
  return `
    ${ct(
      "rounded",
      "border",
      "border-solid",
      "m-0",
      "p-2",
      "text-sm",
      failedValidation ? "bg-red-100" : "bg-white",
      failedValidation ? "border-red-500" : "border-gray-200",
      "focus:bg-white",
      "focus:border-blue-300",
      "focus:shadow-blue",
    )}
    w-[calc(100%-1rem)]
    placeholder:text-gray-500
  `;
};

export const dropdownStyle = (failedValidation: boolean | undefined) => {
  return `
    ${ct(
      "rounded",
      "border",
      "border-solid",
      "h-9",
      "m-0",
      "p-2",
      "text-sm",
      "w-full",
      failedValidation ? "bg-red-100" : "bg-white",
      failedValidation ? "border-red-500" : "border-gray-200",
      "focus:bg-white",
      "focus:border-blue-300",
      "focus:shadow-blue",
    )}
    w-[calc(100%+2px)]
  `;
};

export const leadGenButtonStyle = ct(
  "border-none",
  "cursor-pointer",
  "h-auto",
  "text-sm",
  "md:text-base",
  "font-semibold",
  "flex",
  "whitespace-nowrap",
  "items-center",
  "px-5",
  "py-2",
  "rounded",
  "w-fit",
);
